export default __webpack_public_path__ + "static/media/Mobile Icon.83e469c2.svg";